import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import VeiculosService from '../../../services/veiculos';
import { Link } from 'react-router-dom';
import Exportar from '../../shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [modelo, setModelo] = useState("");
    const [situacao, setSituacao] = useState("");
    const [secretaria, setSecretaria] = useState("");
    const [categoria, setCategoria] = useState("");

    const busca = async (query) => {
        if (query == "") {
            await props.fetchVeiculos()
            setModelo("")
            setSecretaria("")
            setSituacao("")
            setCategoria("")
        } else {
            var response = await VeiculosService.buscar(query)
            if (response.data.length >= 1) {
                props.setVeiculos(response.data)
                props.setVazio(false)
                setModelo("")
                setSecretaria("")
                setSituacao("")
                setCategoria("")
            } else {
                props.setVazio(true)
                setModelo("")
                setSecretaria("")
                setSituacao("")
                setCategoria("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (modelo) prepQuery = prepQuery + `&modelo=${encodeURI(modelo)}`;
        if (secretaria !== "false" && secretaria != "false" && secretaria !== "") prepQuery = prepQuery + `&secretaria=${encodeURI(secretaria)}`;
        if (situacao !== "false" && situacao != "false" && situacao !== "") prepQuery = prepQuery + `&situacao=${encodeURI(situacao)}`;
        if (categoria !== "false" && categoria != "false" && categoria !== "") prepQuery = prepQuery + `&categoria=${encodeURI(categoria)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Secretaria">
                                <FloatingLabel
                                    label="Secretaria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Secretaria"
                                        name="secretaria"
                                        onChange={e => setSecretaria(e.target.value)}
                                    >
                                        <option>TODAS</option>
                                        {props.secretarias.map((sec) =>
                                            <option value={sec.nome}>{sec.nome}</option>
                                        )}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Situação">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="situacao"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option>TODAS</option>
                                        <option value="Ativo">Ativo</option>
                                        <option value="Inativo">Inativo</option>
                                        <option value="Em Manutenção">Em Manutenção</option>
                                        <option value="Aguardando Leilão">Aguardando Leilão</option>
                                        <option value="Perda Total">Perda Total</option>
                                        <option value="Leiloado">Leiloado</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="modelo">
                                <FloatingLabel
                                    label="Modelo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="modelo"
                                        value={modelo}
                                        onChange={e => setModelo(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Categoria">
                                <FloatingLabel
                                    label="Categoria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="categoria"
                                        name="categoria"
                                        onChange={e => setCategoria(e.target.value)}
                                    >
                                        <option>TODAS</option>
                                        <option value="Próprio">Próprio</option>
                                        <option value="Locado">Locado</option>
                                        <option value="Doado">Doado</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/orgaos'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                     <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.veiculos} nome={"Veiculos"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#097e8437-6ee1-47df-b2a6-7543e88d3a11" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca